import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const API = process.env.REACT_APP_BACKEND_URL;

// Placeholder stories shown ONLY until real approved testimonials exist. Replace via /member/testimonials + admin approval.
const PLACEHOLDERS = [
  { quote: "My companion here changed everything. When I'm struggling at 2am, they're always there.", author: 'Michael R.', role: 'Nairobi, Kenya · 3 months in recovery' },
  { quote: 'The Walk It Out course gave me a roadmap when I felt completely lost. Week by week, I found hope again.', author: 'Linda M.', role: 'Manila, Philippines · Spouse of addict' },
  { quote: 'As a mother watching my daughter destroy herself, I was drowning. My companion taught me how to set boundaries.', author: 'Patricia W.', role: 'Lagos, Nigeria · Mother of addict' },
];

export const RealTestimonials = ({ colors }) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    fetch(`${API}/api/testimonials/public?limit=6`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        const real = (d?.testimonials || []).map((t) => ({
          quote: t.testimonial_text,
          author: t.is_anonymous ? 'Anonymous' : t.member_name,
          role: t.member_type === 'church' ? 'Church partner' : t.country || t.role || 'Member',
        }));
        setItems(real);
      })
      .catch(() => setItems([]));
  }, []);
  if (items === null) return null;
  const real = items.length > 0;
  const list = real ? items : PLACEHOLDERS;
  const navy = colors?.navy || '#1B2A41';
  const sage = colors?.sage || '#8A9A86';
  return (
    <div data-testid="real-testimonials" data-real={real ? '1' : '0'}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem', maxWidth: 1100, margin: '0 auto' }}>
        {list.map((t, i) => (
          <motion.blockquote key={i} data-testid={`testimonial-${i}`} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ delay: i * 0.1 }}
            style={{ margin: 0, background: '#fff', border: `1px solid ${sage}44`, borderRadius: 16, padding: '1.75rem', textAlign: 'left', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <p style={{ fontFamily: 'var(--font-heading)', fontSize: '1.1rem', lineHeight: 1.6, color: navy, margin: 0, fontStyle: 'italic', textAlign: 'left' }}>"{t.quote}"</p>
            <footer style={{ fontSize: '0.85rem', color: '#4B5563', borderTop: `1px solid ${sage}33`, paddingTop: '0.75rem', textAlign: 'left' }}>
              <strong style={{ color: navy }}>{t.author}</strong> · {t.role}
            </footer>
          </motion.blockquote>
        ))}
      </div>
      <p style={{ textAlign: 'center', fontSize: '0.75rem', color: '#9CA3AF', marginTop: '1.25rem' }}>
        {real ? 'Shared by members with their permission.' : 'Illustrative stories — names changed. Real member stories are added as they are shared with permission.'}
      </p>
    </div>
  );
};
